import React from 'react';
import _ from 'lodash';
import { Alert } from 'componentLibrary';
import {Header, Button} from 'semantic-ui-react';

const ViewAddedSubApplicationCard = ({
  data,
  singleApplication,
  closeModal,
  showResultsView,
  isAddingToAmendment,
  searchOption
}) => {
  let applications = undefined;
  if (singleApplication) {
    applications = <Header as="h4">{data.title}</Header>;
  } else {
    applications = _.map(data, (application, index) => {
      return (
        <Header as="h4" key={index}>
          {application.applicationTitle}
        </Header>
      );
    });
  }
  return (
    <React.Fragment>
      <Alert
        size="tiny"
        header={isAddingToAmendment ? searchOption === 'subgrant' ? 'The following subgrant is being added to this amendment.' : "The following subapplication is being added to this amendment." : "The following subapplication(s) has been successfully added to the application"}
        type="success"
        dismissable={false}
      >
        <br />
        <br />
        {applications}
        {isAddingToAmendment && <>
          <br />
          <br />
          This process may take a few minutes and you cannot submit your task until it has completed.
        </>}
      </Alert>
      <Button
        primary
        icon
        id="viewApplicationPage"
        title={isAddingToAmendment ? "View budget or scope section" : "View added subapplication's page"}
        onClick={() => closeModal()}
      >
        {isAddingToAmendment ? "View budget or scope section" : "View added subapplication's page"}
      </Button>
      {`  `}
      <a id="viewApplictionPageLink" href="#" onClick={(event) => showResultsView(event)}>
        Return to search result
      </a>
    </React.Fragment>
  );
};

export default ViewAddedSubApplicationCard;
